import React from "react";
import CopyURL from "components/CopyURL";

const DIMENSIONS = { width: 12, height: 12 };

const TrafficLights = () => (
  <div className="flex flex-row">
    <div style={DIMENSIONS} className="br-100 bg-red"></div>
    <div style={DIMENSIONS} className="br-100 bg-yellow ml2"></div>
    <div style={DIMENSIONS} className="br-100 bg-green ml2"></div>
  </div>
);

const BrowserBezel = ({ href, copy, placeholder, children }) => {
  return (
    <div className="flex flex-column w-100">
      <div className="flex flex-row w-100 bg-white br--top ba br2 ph3 items-center bt bb hairline-1 pv2 relative">
        <TrafficLights />
        <CopyURL href={href} copy={copy} placeholder={placeholder} />
      </div>
      {children && (
        <div className="bl bb br br--bottom hairline-1">{children}</div>
      )}
    </div>
  );
};

export default BrowserBezel;
